import Model from "./base/model";

class SimulationQuotesFiles extends Model {
  resourceName() {
    return "simulation_quotes_files";
  }

  fields() {
    return {
      simulation_quote: {jsonApi: "hasOne", type: "simulation_quotes"},
      name: "",
      path: "",
      download: "",
      simulation_quote_id: "",
      simulation_quote_transporter_id: "",
      type: "",
      related_file_id: "",
    };
  }


}

export default new SimulationQuotesFiles();
